import CustomTable from "../../CustomTable";
import { pdficon4, plusicon } from "../../imagepath";
import React, { useContext, useEffect, useState } from "react";
import { Modal, DatePicker, Button, message, Form } from "antd";
import moment from "moment";
import { CSVLink } from "react-csv";
import { PlanCuidadoContext } from "../../../context/PlanCuidadoContextProvider";
import { Select } from "antd";
import { post } from "../../../services/base";
import {
  actualizarEstatusActividad,
  crearActividades,
} from "../../../services/actividades";
import metasType from "../../../utils/enums/metasTypes";
import { GestoresContext } from "../../../context/GestoresContext";
import {
  actividadesCode,
  tipoActividades,
} from "../../../utils/enums/statusCodes";
import { ExclamationCircleFilled } from "@ant-design/icons";
import {procedenciasCode} from "../../../utils/enums/statusCodes";
import { obtenerMetas } from "../../../services/dim";

const Actividades = () => {
  const { planesCuidadoData, updatePlanesCuidadoData, planesCuidadoOpciones } =
    useContext(PlanCuidadoContext);
  const { gestores } = useContext(GestoresContext);
  const [selectedPlanAsociado, setSelectedPlanAsociado] = useState(null);
  const [selectedActividad, setSelectedActividad] = useState(null);
  const [selectedResponsable, setSelectedResponsable] = useState(null);
  const [actividadesListado, setActividadesListado] = useState([]);
  const [fechaLimite, setFechaLimite] = useState(null);
  const [meta, setMeta] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [metas, setMetas] = useState([]);
  const [actividadesForm] = Form.useForm();
  const actividades = planesCuidadoData
    ? planesCuidadoData.reduce(
        (acc, plan) => acc.concat(plan.actividades || []),
        []
      )
    : [];

  const handleCerrarAgregarPlan = () => {
    actividadesForm.resetFields();
    setModalVisible(false);
    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const metas = await obtenerMetas();
        setMetas(metas);

      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);
  const handleFechaLimite = (date, dateString) => {
    setFechaLimite(dateString);
  };

  const handleEstatusActividad = async (actividad, codigoEstatus, estatus) => {
    try {
      const { confirm } = Modal;
      confirm({
        title: "Actualización Estado Actividad",
        icon: <ExclamationCircleFilled />,
        content:
          "¿Está seguro que desea actualizar la actividad del paciente a " +
          estatus.children +
          "?",
        okText: "Si",
        cancelText: "No",
        onOk() {
          return new Promise((resolve, reject) => {
            actualizarEstatusActividad(actividad.id, {
              estatus: codigoEstatus,
            }).then(() => {
              updatePlanesCuidadoData();
              resolve();
            });
          }).catch(() => console.log("Oops errors!"));
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const columns = [
    {
      title: "Intervención",
      dataIndex: "actividadDe",
      key: "actividadDe",
      sorter: (a, b) => a.actividadDe.localeCompare(b.actividadDe),
      searchable: true,
    },
    {
      title: "Plan Asociado",
      dataIndex: "planAsociado",
      key: "planAsociado",
      sorter: (a, b) => a.planAsociado.localeCompare(b.planAsociado),
      searchable: true,
    },
    {
      title: "Fecha límite",
      dataIndex: "fechaLimite",
      key: "fechaLimite",
      sorter: (a, b) => a.fechaLimite.localeCompare(b.fechaLimite),
      searchable: true,
    },
    {
      title: "Responsable",
      dataIndex: "responsable",
      key: "responsable",
      sorter: (a, b) => a.responsable.localeCompare(b.responsable),
      searchable: true,
    },
    {
      title: "Estatus",
      dataIndex: "estatus",
      key: "estatus",
      sorter: (a, b) => a.estatus.localeCompare(b.estatus),
      render: (text, record) => (
        <Select
          defaultValue={record.estatus}
          style={{ width: 120, color: "blue" }}
          onChange={(value, label) =>
            handleEstatusActividad(record, value, label)
          }
        >
          <Option value={actividadesCode.Activa.value}>
            {actividadesCode.Activa.text}
          </Option>
          <Option value={actividadesCode.Incompleta.value}>
            {actividadesCode.Incompleta.text}
          </Option>
          <Option value={actividadesCode.Finalizada.value}>
            {actividadesCode.Finalizada.text}
          </Option>
        </Select>
      ),
    },
  ];

  const rowSelection = {
  };
  const handlePlanSelection = async (value, label) => {
    setSelectedPlanAsociado(value);
    try {
      const response = await post(
        "/PlanesCuidado/actividades/listado",
        JSON.stringify({ descripcion: label.children, tipo: "1" })
      );
      const data = response.data[0];

      const formattedData = {
        actividades: data.actividades.map((activity) => ({
          id: activity.codigo,
          descripcion: activity.descripcion,
          fecha: activity.fecha,
          tipoActividad: activity.tipoActividad,
        })),
      };

      setActividadesListado(formattedData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleAgregarActividad = async () => {
    actividadesForm
      .validateFields()
      .then(async (values) => {
        if (
          values != undefined &&
          values.errorFields != undefined &&
          values.errorFields.length > 0
        ) {
          message.error("Los campos marcados son requeridos");
          setLoading(false);
          return;
        } else {
          try {
            setLoading(true);
            const data = [
              {
                codigoActividad: selectedActividad.value.toString(),
                descripcionActividad: selectedActividad.label,
                codigoMeta: meta.value,
                responsable: selectedResponsable,
                fechaLimite: moment(fechaLimite).format("YYYY-MM-DD"),
                meta : "",
              },
            ];
            await crearActividades(selectedPlanAsociado, data);
            message.success("Actividad agregada exitosamente.");
            updatePlanesCuidadoData();
            handleCerrarAgregarPlan();
          } catch (error) {
            console.error("Error agregando actividad:", error);
            message.error(
              "Error al agregar actividad. Por favor, inténtelo de nuevo más tarde."
            );
          }
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  return (
    <div className="card">
      <div className="card-header pb-0">
        <h4 className="card-title d-inline-block">Intervenciónes</h4>{" "}
      </div>
      {actividades && (
        <CustomTable
          dataSource={actividades}
          columns={columns}
          rowSelection={rowSelection}
          updateDataSource={updatePlanesCuidadoData || []}
          contexto={procedenciasCode.Actividad.value}
        />
      )}
      {actividades && actividades.length > 0 && (
        <Button
          className="btn btn-primary add-pluss ms-2"
          onClick={() => setModalVisible(true)}
        >
          <img src={plusicon} alt="#" />
          Agregar
        </Button>
      )}
      <Modal
        title="Agregar actividad"
        open={modalVisible}
        onCancel={handleCerrarAgregarPlan}
        footer={[
          <Button key="cancel" onClick={handleCerrarAgregarPlan}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleAgregarActividad}
          >
            Agregar
          </Button>,
        ]}
        centered
        style={{
          zIndex: 1042,
        }}
      >
        <div className="row">
          <div className="col-sm-12">
            <br></br>
            <Form form={actividadesForm}>
              <div className="row">
                <div className="col-12 col-md-6 col-xl-12">
                  <div className="form-group local-forms">
                    <label>
                      Plan Asociado <span className="login-danger">*</span>
                    </label>
                    <Form.Item
                      name={"Plan Asociado"}
                      rules={[{ required: true, message: "Es requerido" }]}
                    >
                      <Select
                        id="buscar-plan-asociado"
                        style={{ width: "100%" }}
                        value={selectedPlanAsociado}
                        onChange={(value, label) =>
                          handlePlanSelection(value, label)
                        }
                      >
                        {planesCuidadoOpciones &&
                          planesCuidadoOpciones.length > 0 &&
                          planesCuidadoOpciones.map((plan) => (
                            <Option key={plan.value} value={plan.value}>
                              {plan.label}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-8">
                    <div className="form-group local-forms">
                      <label>
                        Intervención <span className="login-danger">*</span>
                      </label>
                      <Form.Item
                        name={"Actividad"}
                        rules={[{ required: true, message: "Es requerida" }]}
                      >
                        <Select
                          id="buscar-plan-asociado"
                          onChange={(value, option) =>
                            setSelectedActividad({
                              value: value,
                              label: option.children,
                            })
                          }
                          style={{ width: "100%" }}
                        >
                          {actividadesListado.actividades &&
                            actividadesListado.actividades.length > 0 &&
                            actividadesListado.actividades.map((actividad) => (
                              <Option key={actividad.id} value={actividad.id}>
                                {actividad.descripcion}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-xl-4">
                    <div className="form-group local-forms">
                      <label>
                        Responsable <span className="login-danger">*</span>
                      </label>
                      <Select
                        id="buscar-responsable"
                        defaultValue={selectedResponsable}
                        onChange={setSelectedResponsable}
                        style={{ width: "100%" }}
                      >
                        {gestores &&
                          gestores.length > 0 &&
                          gestores.map((gestor) => (
                            <Option
                              key={gestor.usuarioId}
                              value={gestor.usuarioId}
                            >
                              {gestor.gestor}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-12">
                  <div className="form-group local-forms">
                      <label>
                      Meta <span className="login-danger">*</span>
                      </label>
                      <Form.Item
                        name={"Meta"}
                        rules={[{ required: true, message: "Es requerida" }]}
                      >
                        <Select
                          id=""
                          onChange={(value, option) =>
                            setMeta({
                              value: value,
                              label: option.children,
                            })
                          }
                          style={{ width: "100%" }}
                        >
                          {metas &&
                            metas.length > 0 &&
                            metas.map((meta) => (
                              <Option key={meta.value} value={meta.value}>
                                {meta.label}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-xl-12">
                  <div className="form-group local-forms cal-icon">
                    <label>
                      Fecha límite <span className="login-danger">*</span>
                    </label>
                    <Form.Item
                      name={"Fecha límite"}
                      rules={[{ required: true, message: "Es requerida" }]}
                    >
                      <DatePicker
                        className="form-control datetimepicker"
                        onChange={handleFechaLimite}
                        placeholder=""
                        suffixIcon={null}
                      />
                    </Form.Item>
                    {/* <input
                                        className="form-control datetimepicker"
                                        type="text"
                                    /> */}
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Actividades;
